import { captchaAxios } from 'api/config'

export const transcribeVoice = async (chatId: string, audio: Blob): Promise<string> => {
  const formData = new FormData()
  // Server accepts any audio/* (video/webm included); extension is informational only.
  formData.append('file', audio, 'voice-message')
  const { data } = await captchaAxios.post<{ text: string }>(`chats/${chatId}/voice/transcribe`, formData)
  return data.text ?? ''
}

/** TTS replay of a bot message: server acks 201 and streams the audio over the WS room
 *  named after the MESSAGE id (join it before calling) as stream_audio/end_stream_audio.
 *  Replay events carry no seq: the player appends them in arrival order. */
export const readChatMessage = async (messageId: string): Promise<void> => {
  await captchaAxios.post(`chat-messages/${messageId}/read`)
}
